var render = function render(){var _vm=this,_c=_vm._self._c;return _c('confirm-btn',{attrs:{"color":"error","loading":_vm.loading,"text":_vm.text,"icon":_vm.icon,"fab":_vm.fab,"rounded":_vm.rounded,"outlined":_vm.outlined,"dark":_vm.dark,"btn-class":_vm.btnClass,"small":_vm.small,"block":_vm.block},on:{"confirmed":_vm.onDelete}},[_c('v-icon',{attrs:{"small":_vm.smallIcon}},[_vm._v(" mdi-delete-forever ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }